export default __webpack_public_path__ + "static/media/rating.8ad897b5.png";